// extracted by mini-css-extract-plugin
export default {"colorMain1":"#6d64c6","colorMain2":"#453ca2","wrapper":"styles_wrapper__6OkaA","item":"styles_item__2AkUC","itemActive":"styles_itemActive__6dHdf"};